import React from "react";
import { Link } from "react-router-dom";

const LivesChanged = () => {
  const stories = [
    {
      id: 1,
      name: "Sarah M.",
      age: 8,
      condition: "Leukemia",
      story:
        "Sarah was diagnosed with leukemia at age 6 and has been fighting bravely for 2 years. She loves drawing and dreams of becoming an artist. Thanks to the support from Togi's Max Wins donations, Sarah is now in remission and back to creating her beautiful artwork!",
      impact: "Covered her latest treatment cycle",
      photo: "👧",
      status: "In Remission",
      color: "from-pink-500/20 to-purple-500/20",
      borderColor: "border-pink-400/30",
    },
    {
      id: 2,
      name: "Alex K.",
      age: 12,
      condition: "Bone Cancer",
      story:
        "Alex has been battling bone cancer with incredible strength. He loves basketball and dreams of playing professionally one day. He never stops practicing, even during chemo. The donations helped his family with medical bills, and Alex is now back on the court!",
      impact: "Helped with medical bills and treatment",
      photo: "🏀",
      status: "Recovering",
      color: "from-blue-500/20 to-green-500/20",
      borderColor: "border-blue-400/30",
    },
    {
      id: 3,
      name: "Emma L.",
      age: 10,
      condition: "Brain Cancer",
      story:
        "Emma is a brilliant 10-year-old who wants to cure cancer when she grows up. She's been fighting brain cancer for 18 months with incredible courage. Emma loves science experiments and dreams of becoming a researcher. The support helped her family during treatment, and Emma is now back in school!",
      impact: "Supported family during treatment",
      photo: "🔬",
      status: "In Treatment",
      color: "from-green-500/20 to-blue-500/20",
      borderColor: "border-green-400/30",
    },
    {
      id: 4,
      name: "Maya R.",
      age: 7,
      condition: "Lymphoma",
      story:
        "Maya is a sweet 7-year-old who loves animals and wants to be a veterinarian. She was diagnosed with lymphoma and has been undergoing treatment for 8 months. The donations helped cover her family's medical expenses, allowing Maya to focus on getting better.",
      impact: "Covered medical expenses",
      photo: "🐾",
      status: "In Treatment",
      color: "from-yellow-500/20 to-orange-500/20",
      borderColor: "border-yellow-400/30",
    },
    {
      id: 5,
      name: "Jake T.",
      age: 14,
      condition: "Osteosarcoma",
      story:
        "Jake is a determined teenager who loves skateboarding and music. He was diagnosed with osteosarcoma in his leg and had to undergo surgery and chemotherapy. Thanks to the support, Jake's family could focus on his recovery, and he's now back to playing guitar!",
      impact: "Supported family during surgery and recovery",
      photo: "🎸",
      status: "Recovering",
      color: "from-purple-500/20 to-pink-500/20",
      borderColor: "border-purple-400/30",
    },
    {
      id: 6,
      name: "Lily C.",
      age: 9,
      condition: "Neuroblastoma",
      story:
        "Lily is a creative 9-year-old who loves painting and dancing. She was diagnosed with neuroblastoma and has been fighting for over a year. The donations helped her family with treatment costs, and Lily is now back to her art classes and dance lessons!",
      impact: "Helped with treatment costs",
      photo: "🎨",
      status: "In Remission",
      color: "from-indigo-500/20 to-purple-500/20",
      borderColor: "border-indigo-400/30",
    },
  ];

  const totalLivesChanged = stories.length;
  const inRemission = stories.filter(
    (story) => story.status === "In Remission"
  ).length;
  const recovering = stories.filter(
    (story) => story.status === "Recovering"
  ).length;
  const inTreatment = stories.filter(
    (story) => story.status === "In Treatment"
  ).length;

  return (
    <div className="max-w-6xl w-full">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-green-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
          💚 Lives Changed 💚
        </h1>
        <p className="text-gray-300 text-xl max-w-3xl mx-auto">
          Real stories of hope, courage, and healing. Meet the incredible kids
          whose lives have been touched by Togi's Max Wins donations.
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
        <div className="bg-gradient-to-r from-green-500/20 to-blue-500/20 backdrop-blur-sm p-6 rounded-2xl border border-green-400/30">
          <h3 className="text-green-400 font-bold text-3xl mb-2">
            {totalLivesChanged}
          </h3>
          <p className="text-gray-300">Lives Touched</p>
        </div>
        <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm p-6 rounded-2xl border border-blue-400/30">
          <h3 className="text-blue-400 font-bold text-3xl mb-2">
            {inRemission}
          </h3>
          <p className="text-gray-300">In Remission</p>
        </div>
        <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm p-6 rounded-2xl border border-purple-400/30">
          <h3 className="text-purple-400 font-bold text-3xl mb-2">
            {recovering}
          </h3>
          <p className="text-gray-300">Recovering</p>
        </div>
        <div className="bg-gradient-to-r from-pink-500/20 to-yellow-500/20 backdrop-blur-sm p-6 rounded-2xl border border-pink-400/30">
          <h3 className="text-pink-400 font-bold text-3xl mb-2">
            {inTreatment}
          </h3>
          <p className="text-gray-300">In Treatment</p>
        </div>
      </div>

      {/* Stories Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {stories.map((story) => (
          <div
            key={story.id}
            className={`bg-gradient-to-br ${story.color} backdrop-blur-sm rounded-2xl p-6 border ${story.borderColor} hover:scale-105 transition-all duration-300`}
          >
            {/* Header */}
            <div className="flex items-center gap-4 mb-4">
              <div className="text-4xl">{story.photo}</div>
              <div>
                <h3 className="text-white font-bold text-xl">{story.name}</h3>
                <p className="text-gray-300 text-sm">
                  Age {story.age} • {story.condition}
                </p>
              </div>
            </div>

            {/* Status Badge */}
            <div className="mb-4">
              <span
                className={`px-3 py-1 rounded-full text-xs font-bold ${
                  story.status === "In Remission"
                    ? "bg-green-500/20 text-green-400 border border-green-400/30"
                    : story.status === "Recovering"
                    ? "bg-blue-500/20 text-blue-400 border border-blue-400/30"
                    : "bg-yellow-500/20 text-yellow-400 border border-yellow-400/30"
                }`}
              >
                {story.status}
              </span>
            </div>

            {/* Story */}
            <div className="text-gray-300 leading-relaxed mb-4 text-sm">
              {story.story}
            </div>

            {/* Impact */}
            <div className="bg-black/20 rounded-lg p-3 border border-gray-600/30">
              <div className="text-green-400 font-bold text-sm mb-1">
                💚 Impact Made
              </div>
              <div className="text-gray-300 text-sm">{story.impact}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="text-center mt-12">
        <div className="bg-gradient-to-r from-green-500/20 to-blue-500/20 backdrop-blur-sm rounded-2xl p-8 border border-green-400/30">
          <h2 className="text-2xl font-bold text-white mb-4">
            Help Change More Lives
          </h2>
          <p className="text-gray-300 mb-6">
            Every Max Win donation directly supports kids fighting cancer. Your
            contribution can make a real difference in their journey to
            recovery.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-lg hover:shadow-green-500/25"
          >
            <span>💚</span>
            Make a Donation
          </Link>
        </div>
      </div>

      {/* Back to Home */}
      <div className="text-center mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-lg hover:shadow-purple-500/25"
        >
          <span>🏠</span>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default LivesChanged;
